import { useEffect, useMemo, useState } from "react";

import DataAggregator from "../dataAggregator/DataAggregator";
import accountTypes from "../../../data/accountTypes";
import ngoTypes from "../../../data/ngoTypes";
import ProfileCard from "../../pages/loggedIn/profiles/ProfileCard";
import getUrlQuery from "../../../controllers/getUrlQuery";
import DropDownInput from "../../helperComponents/DropDownInput";
import DropDownLocationInput from "../../helperComponents/DropDownLocationInput";

export default function ProfileAggregator({
  columns = 1,
  nothingFoundMessage,
  disableFilters,
  inheritedSearchQuery,
  onCardClick,
  hideTitleSection,
  inheritedAccountType,
  inheritedNgoType,
  ItemCard,
  showNgoWithPendingVerification,
  showReportedItems,
}) {
  const [ngoType, setNgoType] = useState(inheritedNgoType);
  const [accountType, setAccountType] = useState(inheritedAccountType);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);

  const queryParams = useMemo(
    () => ({
      ngoType,
      accountType,
      showNgoWithPendingVerification,
      state,
      city,
    }),
    [ngoType, accountType, showNgoWithPendingVerification, state, city]
  );

  return (
    <DataAggregator
      showReportedItems={showReportedItems}
      hideTitleSection={hideTitleSection}
      onCardClick={onCardClick}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      nothingFoundMessage={nothingFoundMessage}
      columns={columns}
      doReset={() => {
        setAccountType(null);
        setNgoType(null);
      }}
      permissionName={"profilePermissions"}
      queryParams={queryParams}
      filters={
        <>
          <DropDownInput
            label="Type"
            value={accountType}
            options={accountTypes}
            onChange={setAccountType}
          />

          <DropDownInput
            label="Ngo Type"
            value={ngoType}
            options={ngoTypes}
            onChange={setNgoType}
          />

          <DropDownLocationInput
            type="STATE"
            country="IN"
            value={state}
            onChange={setState}
          />

          <DropDownLocationInput
            type="CITY"
            state={state}
            country="IN"
            value={city}
            onChange={setCity}
          />
        </>
      }
      title="Accounts"
      path="profiles"
      CardComponent={ItemCard ? ItemCard : ProfileCard}
    />
  );
}
